import "./assets/main.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router.admin";

// Luxon
import { Settings } from "luxon";

// Toast
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

// TTS Directive
import { installTtsDirective } from "@shared-directives/tts.directive";
import { setTtsEngine } from "@shared-utils/accessibility/tts.utils";
import WebIosTtsEngine from "@shared-utils/accessibility/web.ios.tts.engine";
import { installSafeHtmlDirective } from "@shared-directives/safe-html.directive";

Settings.defaultLocale = "fr";

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);
app.use(pinia);
app.use(router);
app.use(Toast, {
	position: POSITION.BOTTOM_CENTER,
	timeout: 6000,
	closeOnClick: true,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	draggable: true,
	closeButton: "button",
});

// Installe la directive v-tts
setTtsEngine(new WebIosTtsEngine());
installTtsDirective(app);
installSafeHtmlDirective(app);

app.mount("#app");
